import { useEffect, useRef } from 'react';

export default function Sobre() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="sobre" className="py-24 md:py-32 bg-white overflow-hidden">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">

          {/* Image Column */}
          <div className="reveal opacity-0 translate-y-8 transition-all duration-700" style={{ transitionProperty: 'opacity, transform' }}>
            <div className="relative">
              {/* Decorative background shape */}
              <div className="absolute -top-6 -left-6 w-full h-full bg-[#D6C4D6]/20 rounded-[2rem]" />
              {/* Main image container */}
              <div className="relative rounded-[2rem] overflow-hidden" style={{ height: '560px' }}>
                <img
                  src="https://storage.readdy-site.link/project_files/3f7186ef-158a-4704-a75d-2965a55f3c17/6f475b45-8235-44a4-a012-1d4d99c1c02e_INTRE-FOTO.jpeg?v=12763687e51a45b6fdb923788fbd5137"
                  alt="Arquiteta INTRÊ Arquitetura - Design de Interiores São Paulo"
                  className="w-full h-full object-cover object-top"
                />
                {/* Subtle overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#301531]/20 to-transparent" />
              </div>
              {/* Accent border */}
              <div className="absolute -bottom-4 -right-4 w-32 h-32 border-2 border-[#D6C4D6] rounded-[1.5rem]" />
            </div>
          </div>

          {/* Text Column */}
          <div className="flex flex-col gap-6">
            <div className="reveal opacity-0 translate-y-8 transition-all duration-700" style={{ transitionProperty: 'opacity, transform' }}>
              <span className="inline-flex items-center gap-2 px-4 py-1.5 border border-[#D6C4D6] text-[#301531] font-montserrat text-xs font-semibold tracking-[0.2em] uppercase rounded-full">
                Sobre nós
              </span>
            </div>

            <div className="reveal opacity-0 translate-y-8 transition-all duration-700" style={{ transitionProperty: 'opacity, transform' }}>
              <h2 className="font-gothic text-[#301531] leading-tight" style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)' }}>
                Transformamos espaços com propósito e sofisticação
              </h2>
            </div>

            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 space-y-5" style={{ transitionProperty: 'opacity, transform' }}>
              <p className="font-montserrat text-[#1A1A1A] text-base leading-relaxed">
                A <strong>INTRÊ Arquitetura</strong> nasceu da crença de que um projeto de interiores vai muito além da estética — é sobre entender profundamente quem você é, como você vive e o que você precisa para se sentir em casa.
              </p>
              <p className="font-montserrat text-[#1A1A1A] text-base leading-relaxed">
                Oferecemos um <strong>atendimento completo e próximo</strong>, do primeiro contato até a entrega final. Cada projeto é desenvolvido com planejamento estratégico, garantindo que cada decisão seja tomada com intenção — sem desperdício de tempo, dinheiro ou energia.
              </p>
              <p className="font-montserrat text-[#1A1A1A] text-base leading-relaxed">
                Nosso diferencial está no <strong>entendimento profundo do cliente</strong>: ouvimos, interpretamos e traduzimos seus desejos em ambientes funcionais, elegantes e verdadeiramente seus.
              </p>
            </div>

            {/* Stats */}
            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 grid grid-cols-3 gap-6 pt-4 border-t border-[#D6C4D6]/40" style={{ transitionProperty: 'opacity, transform' }}>
              {[
                { number: '14+', label: 'Projetos entregues' },
                { number: '100%', label: 'Satisfação dos clientes' },
                { number: '5+', label: 'Anos de experiência' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-gothic text-[#301531] font-bold text-2xl md:text-3xl">{stat.number}</div>
                  <div className="font-montserrat text-[#BCBDBF] text-xs mt-1 leading-tight">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="reveal opacity-0 translate-y-8 transition-all duration-700 flex justify-center lg:justify-start" style={{ transitionProperty: 'opacity, transform' }}>
              <a
                href="https://wa.me/5511930672567"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-[#301531] text-white font-montserrat font-semibold text-sm rounded-full hover:bg-[#4a2050] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Conheça nosso trabalho
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
